<template>
  <div class="ldgl-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" @submit.native.prevent>
            <el-form-item label="关键字">
              <el-input v-model="search" placeholder="关键字搜索" style="width: 230px;" @keyup.enter.native="Search"/>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="addTemplate">添加规则</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="报价分类"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.type===0">板材</span>
                      <span v-if="scope.row.type===1">铝材</span>
                      <span v-if="scope.row.type===2">配件</span>
                      <span v-if="scope.row.type===3">其他费用</span>
                      <span v-if="scope.row.type===4">木架</span>
                      <span v-if="scope.row.type===5">调色费</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="key"
                    label="关键字"
                    width="160"
                    align="center"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="discount"
                    label="折扣"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    min-width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button icon="el-icon-edit" size="mini" @click="editTemplate(scope.row)">修改</el-button>
                      <el-button icon="el-icon-delete" size="mini" @click="deleteTemplate(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="420px">
      <el-form ref="addForm" size="small" label-width="90px" :model="addForm" :rules="addRules">
        <el-form-item label="报价分类" prop="type">
          <el-select v-model="addForm.type" style="width: 120px" filterable clearable>
            <el-option v-for="item in typeList" :key="item.type" :label="item.typeName" :value="item.type" />
          </el-select>
        </el-form-item>
        <el-form-item label="关键字" prop="key">
          <el-input v-model="addForm.key" placeholder="请输入关键字" maxlength="20" show-word-limit>
            <template slot="append"><b>*</b> 星号代表缺省</template>
          </el-input>
        </el-form-item>
        <el-form-item label="输入折扣" prop="discount">
          <el-input v-model="addForm.discount" placeholder="请输入折扣(0-10之间)" onkeyup="value=value.replace(/[^\d.]/g,'')" @keyup.native="checkDiscount" show-word-limit>
            <template slot="append">折</template>
          </el-input>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button :loading="btnLoading" type="primary" @click="submitTemplate">立即提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { addOrEditProductQRules, delProductQRules, getProductQRules } from '@/api/erp'

export default {
  name: 'scbjgz',
  data() {
    return {
      typeList: [{
        type: 0,
        typeName: '板件'
      }, {
        type: 1,
        typeName: '铝材'
      }, {
        type: 2,
        typeName: '配件'
      }, {
        type: 3,
        typeName: '其他费用'
      }, {
        type: 4,
        typeName: '木架'
      }, {
        type: 5,
        typeName: '调色费'
      }],
      search: '',
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      addForm: {
        id: null,
        type: null,
        key: '',
        discount: null
      },
      addRules: {
        type: [{ required: true, message: '请选择报价分类', trigger: 'change' }],
        key: [{ required: true, message: '请输入报价关键字', trigger: 'blur' }],
        discount: [{ required: true, message: '请输入报价折扣', trigger: 'blur' }]
      },
      dialogTitle: '',
      dialogVisible: false,
      btnLoading: false
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        key: this.search,
        groupid: this.user.dGroupid
      }
      this.loading = true
      getProductQRules(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    addTemplate() {
      this.addForm.id = null
      this.addForm.type = null
      this.addForm.key = ''
      this.addForm.discount = null
      this.dialogTitle = '添加生产报价规则'
      this.dialogVisible = true
    },
    editTemplate(row) {
      this.addForm.id = row.id
      this.addForm.type = row.type
      this.addForm.key = row.key
      this.addForm.discount = row.discount
      this.dialogTitle = '修改生产报价规则'
      this.dialogVisible = true
    },
    deleteTemplate(row) {
      this.$confirm('您确定要删除此生产报价规则吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        delProductQRules({ id: row.id }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    },
    submitTemplate() {
      if (!this.btnLoading) {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            const data = {
              id: this.addForm.id,
              type: this.addForm.type,
              key: this.addForm.key,
              discount: this.addForm.discount,
              groupid: this.user.dGroupid
            }
            addOrEditProductQRules(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.btnLoading = false
              this.dialogVisible = false
              this.getData()
            }).catch(() => {
              this.btnLoading = false
            })
          } else {
            return false
          }
        })
      }
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    checkDiscount() {
      if (this.addForm.discount < 0 || this.addForm.discount > 10 || isNaN(Number(this.addForm.discount))) {
        this.$message.error('请输入正确的（0-10之间）折扣')
        this.addForm.discount = null
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.ldgl-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
